import { render, staticRenderFns } from "./-TypeOfServices.vue?vue&type=template&id=16f7a6eb&scoped=true&"
import script from "./-TypeOfServices.vue?vue&type=script&lang=js&"
export * from "./-TypeOfServices.vue?vue&type=script&lang=js&"
import style0 from "./-TypeOfServices.vue?vue&type=style&index=0&id=16f7a6eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7a6eb",
  null
  
)

export default component.exports